import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import FormHelperText from '@material-ui/core/FormHelperText'
import isEmpty from 'lodash/isEmpty'
import { getErrorMessage } from '../../utils/formErrorUtils'
import CurrencyInput from 'react-currency-input-field'

const useStyles = makeStyles((theme) => ({
    incrementerWrapper: {
        display: 'block',
        width: '100%',
        maxWidth: '150px',
        whiteSpace: 'nowrap',
        [theme.breakpoints.up(`sm`)]: {
            width: 'auto',
        },
    },
    incrementer: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#CDCDCD',
        borderRadius: '33.5px',
        display: 'inline-block',
        overflow: 'visible',
        height: '2.5rem',
        background: '#fff',
    },
    incrementerInput: {
        maxWidth: '75px',
        height: '100%',
        textAlign: 'center',
        border: '2px solid rgb(116,116,116)',
        background: 'transparent',
        color: 'rgb(61,97,129)',
        verticalAlign: 'top',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    incrementerButton: {
        width: '1.7em',
        height: '100%',
        lineHeight: '0',
        fontSize: '1.5em',
        fontWeight: 'bold',
        padding: '0 !important',
        background: '#fff',
        color: 'rgb(121,121,121)',
        borderColor: 'rgb(116,116,116)',
        borderWidth: '2px',
        borderStyle: 'solid',
        cursor: 'pointer',
        transition: 'background-color .2s',
    },
    incrementerMinus: {
        borderRightWidth: '1px',
        borderRadius: '33.5px 0 0 33.5px',
        color: '#005C59',
        background: '#F4F4F4',
    },
    incrementerPlus: {
        borderLeftWidth: '1px',
        borderRadius: '0 33.5px 33.5px 0',
        color: '#005C59',
        background: '#F4F4F4',
    },
    incrementerLabel: {
        display: 'block',
        textTransform: 'uppercase',
        fontSize: '1.1rem',
        color: 'rgba(0, 0, 0, 0.87) !important',
        fontWeight: 'bold',
    },
    errorText: {
        marginTop: '0.25rem',
        color: theme.palette.error.main,
        [theme.breakpoints.up('md')]: {
            fontSize: '0.85rem',
        },
    },
}))
const incrementerActiveStyle = {
    ':active': { borderStyle: 'solid', background: '#f5f5f5' },
}

const Incrementer = (props) => {
    const classes = useStyles()
    const {
        name,
        onChange,
        value,
        min,
        max,
        incrementSize,
        label,
        directInput,
        errors,
        moneyMode,
    } = props

    const doDecrement = (event) => {
        let newValue = moneyMode
            ? parseFloat(event.target.value)
            : parseInt(event.target.value)
        newValue -= incrementSize
        if (newValue >= min) {
            onChange(moneyMode ? parseFloat(newValue.toFixed(2)) : newValue)
        }
    }

    const doIncrement = (event) => {
        let newValue = moneyMode
            ? parseFloat(event.target.value)
            : parseInt(event.target.value)
        newValue += incrementSize
        if (newValue <= max) {
            onChange(moneyMode ? parseFloat(newValue.toFixed(2)) : newValue)
        }
    }

    const handleMoney = (value, name) => {
        const newValue = parseFloat(value)
        if (isNaN(newValue)) {
            onChange(0)
            return
        }

        onChange(value)
    }

    const handleDirectInput = (event) => {
        const newValue = parseInt(event.target.value, 10)
        if (isNaN(newValue)) {
            onChange(0)
            return
        }

        onChange(newValue)
    }

    return (
        <div
            id={`${name}-incrementer`}
            className={`${classes.incrementerWrapper}`}
        >
            <label className={classes.incrementerLabel} htmlFor={name}>
                {label}
            </label>
            <div className={classes.incrementer}>
                <button
                    id="decrement-button"
                    data-testid={`${name}-decrement-button`}
                    className={
                        classes.incrementerButton +
                        ' ' +
                        classes.incrementerMinus
                    }
                    value={value}
                    onClick={doDecrement}
                >
                    -
                </button>
                {moneyMode ? (
                    <CurrencyInput
                        id="input-example"
                        name={name}
                        className={
                            classes.incrementerInput + ' browser-default'
                        }
                        style={incrementerActiveStyle}
                        value={value}
                        decimalsLimit={2}
                        disabled={!directInput}
                        onValueChange={handleMoney}
                    />
                ) : (
                    <input
                        name={name}
                        type="tel"
                        className={
                            classes.incrementerInput + ' browser-default'
                        }
                        value={value}
                        min={min}
                        max={max}
                        onChange={handleDirectInput}
                        readOnly={!directInput}
                        aria-label={label}
                        style={incrementerActiveStyle}
                        pattern="[0-9]*"
                    />
                )}
                <button
                    id="increment-button"
                    data-testid={`${name}-increment-button`}
                    className={
                        classes.incrementerButton +
                        ' ' +
                        classes.incrementerPlus
                    }
                    value={value}
                    onClick={doIncrement}
                >
                    +
                </button>
            </div>
            {!isEmpty(errors) && (
                <FormHelperText className={classes.errorText}>
                    {getErrorMessage(errors, name)}
                </FormHelperText>
            )}
        </div>
    )
}

export default Incrementer
